import { useEffect } from 'react'
import { abortRequestForDifferentThread } from '../actions/helpers/threadAbortController'

/** @param {object} m */
export function useAbortOnThreadChange(m) {
  const { displayThreadId, chatAbortRef, prevDisplayThreadRef } = m
  useEffect(() => {
    const prev = prevDisplayThreadRef.current
    prevDisplayThreadRef.current = displayThreadId
    if (prev === displayThreadId) return
    if (prev === null && displayThreadId !== null) return
    abortRequestForDifferentThread(chatAbortRef, displayThreadId)
  }, [displayThreadId, chatAbortRef, prevDisplayThreadRef])
}
